import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import {
  getSiteNavigation,
  SWIMBOOKER_PLUS_SIGN_UP_URL,
} from './siteNavigation';

function DesktopNav({ variant, isLoggedIn, onLinkAction }) {
  const navItemClassName = `sh-nav-item brFull gMedium fs-16 ${
    variant === 'light' ? 'white' : 'sb-blue-900'
  }`;

  const toMenuItem = ({ label, to, href, action }) => {
    const text = <span className='gMedium fs-15 sb-blue-900'>{label}</span>;
    if (to) {
      return { key: label, label: <Link to={to}>{text}</Link> };
    }
    if (href) {
      return { key: label, label: <a href={href}>{text}</a> };
    }
    return { key: label, label: text, onClick: () => onLinkAction(action) };
  };

  return (
    <nav aria-label='Main' className='sh-desktop-nav'>
      {getSiteNavigation(isLoggedIn).map(({ title, links }) => (
        <Dropdown
          key={title}
          trigger={['hover', 'click']}
          menu={{ items: links.map(toMenuItem) }}
          overlayClassName='sh-dropdown'
        >
          <Button type='text' className={navItemClassName}>
            {title} <DownOutlined aria-hidden='true' />
          </Button>
        </Dropdown>
      ))}
      <a href={SWIMBOOKER_PLUS_SIGN_UP_URL} className={navItemClassName}>
        swimbooker+
      </a>
      <Link to='/search' className={navItemClassName}>
        Find Fishing
      </Link>
    </nav>
  );
}

export default DesktopNav;
